import { render, staticRenderFns } from "./m_company011.vue?vue&type=template&id=18b0843b&"
import script from "./m_company011.vue?vue&type=script&lang=js&"
export * from "./m_company011.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports